
async function loadModule(moduleName) {
  // Assign the module to a variable:
  // Can't use assert as it's experimental and needs some special settngs for babel
  //const module = await import(/* @vite-ignore */ moduleName, { assert: { type: "json" }});

  // MUST USE w/o assert for loc:vite to work
  // If using assert, it fails in browser due to type error.
  // Just the way it fails for makeRelease and for loc:node.
  const module = await import(/* @vite-ignore */ moduleName);

  //const module = await import(/* @vite-ignore */ moduleName, { assert: { type: "json" }});
  //const module = await import(/* @vite-ignore */ moduleName, { with: { type: "json" }});
  //const module = await import(`${moduleName}`, { assert: { type: "json", "resolution-mode": "import"  }});

  //return module.default;
  return module;
}


function stringToFunctionAndExecute(str) {
  let func = new Function(str);
  return (func()); // <--- note the parenteces
}

function stringToFunctionOnly(str) {
  let func = new Function(str);
  return func;
}

export { loadEnvVar };
async function loadEnvVar(options) {
  const { appCode, appEnv, appMode, appNodeEnv, appVersion, path } = options; 

  const module = await loadModule(path);

  const packageJsonVar = {
    // Following are supplied via package.json
    MODE : appMode,                 // 
    NODE_ENV : appNodeEnv,          //
    APP_VERSION : appVersion,       // takes care of GITVERSION

    //RECALLS_SSG_LIMIT : import.meta.env.VITE_RECALLS_SSG_LIMIT,   // <<<< Is this req'd on client side???
    // Following may not be accessible from client side!!! As it does not start with VITE_xxxx
    // And are not needed on client side. They are either temporary or only for SSG generation
    //GITBRANCH : process.env.GITBRANCH,
    //GITHASH : process.env.GITHASH,
    //GITVERSION : process.env.GITVERSION,
    //SSG : process.env.SSG,
    //SSGTYPE : process.env.SSGTYPE,
  };

  const envVar = { ...module.envVar, ...packageJsonVar};

  return envVar;
}	 
